import { WorkflowSet } from '../../../types';
import { useActiveWorkflow } from '../useActiveWorkflow';

export function useActiveWorkflowOrFail(): WorkflowSet {
  const result = useActiveWorkflow();

  if (!result) {
    throw new Error(
      'Cannot return active workflow: active workflow is missing.',
    );
  }

  return result;
}
